import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WorkflowVariableDescriptor} from '../../conditions/types';
import {Ast, ExpressionCompilerService} from '@ngmedax/expression-compiler';

@Component({
  selector: 'app-workflow-conditions-group',
  templateUrl: './workflow-conditions-group.component.html',
  styleUrls: ['./workflow-conditions-group.component.css']
})
export class WorkflowConditionsGroupComponent {
  @Input() variables: WorkflowVariableDescriptor[] = [];
  @Input() group: Ast.Group = {type: 'group', operator: '&&', elements: []};
  @Output() groupChange = new EventEmitter<Ast.Group>();
  @Input() removable: boolean = true;
  @Output() removeSelf = new EventEmitter<void>();

  public constructor(private compiler: ExpressionCompilerService) {}

  public addRule() {
    const firstVar = this.variables[0];
    const expr: Ast.Expression = { type: 'expression', variable: firstVar?.name || '', operator: '==', value: '' } as any;
    (this.group.elements as any[]).push(expr);
    this.groupChange.emit(this.group);
  }

  public addGroup() {
    const g: Ast.Group = { type: 'group', operator: '&&', elements: [] } as any;
    (this.group.elements as any[]).push(g);
    this.groupChange.emit(this.group);
  }

  public onChildGroupChange(index: number, g: Ast.Group) {
    (this.group.elements as any[])[index] = g;
    this.groupChange.emit(this.group);
  }

  public onChildExpressionChange(index: number, e: Ast.Expression) {
    (this.group.elements as any[])[index] = e;
    this.groupChange.emit(this.group);
  }

  public removeChild(index: number) {
    (this.group.elements as any[]).splice(index, 1);
    this.groupChange.emit(this.group);
  }

  public canSave(): boolean {
    try {
      const currentStmt = this.compiler.compile(this.group);
      return !/(\(\))|(null)|("""+)/.test(currentStmt);
    } catch (e) {
      return false;
    }
  }
}


